import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Alert, Button } from 'reactstrap';
import { updateCard } from '../../../../axios/subscription';
import { toast } from 'react-toastify';

export default function ReplaceCardModal({ open, onClose, PaymentForm, CreditCard, prevCardId }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCardToken = async (tokenResult, buyer) => {
    try {
      setLoading(true);
      console.log('Square token response:', tokenResult, buyer);

      // Prepare payload
      const payload = {
        verificationToken: tokenResult.verificationToken || tokenResult.token,
        cardNonce: tokenResult.token,
        prevCardId: prevCardId || 0
      };

      const res = await updateCard(payload);
      if (res.message == 'success') {
        console.log('Card update API response:', res);
        setLoading(false);
        onClose(); // close modal after success
        toast.success(res.data);
      } else {
        toast.error('Something went wrong ');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong ');
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={open} toggle={loading ? undefined : onClose}>
      <style>{`
        #rswp-card-button {
         display:none
        }
       
      `}</style>
      <ModalHeader toggle={onClose}>Update Card</ModalHeader>
      <ModalBody>
        {error && <Alert color="danger">{error}</Alert>}
        <PaymentForm
          applicationId={import.meta.env.VITE_SQUARE_APPLICATION_ID}
          locationId={import.meta.env.VITE_SUBSCRIPTION_SQAURE_LOCATION_ID}
          overrides={{
            scriptSrc:
              import.meta.env.VITE_SQUARE_ENV === 'production'
                ? 'https://web.squarecdn.com/v1/square.js'
                : 'https://sandbox.web.squarecdn.com/v1/square.js'
          }}
          cardTokenizeResponseReceived={handleCardToken}
          createPaymentRequest={() => ({
            countryCode: 'GB',
            currencyCode: 'GBP',
            total: { label: 'Seamless Slot', amount: '1.00' }
          })}
          createVerificationDetails={() => ({
            amount: '1.00',
            billingContact: {
              addressLines: ['123 Main Street', 'Apartment 1'],
              familyName: 'Doe',
              givenName: 'John',
              countryCode: 'GB',
              city: 'London'
            },
            currencyCode: 'GBP',
            intent: 'CHARGE'
          })}
        >
          <CreditCard
            focus=""
            callbacks={{
              errorClassAdded(event) {
                console.log(event, '-');
                setLoading(false);
              }
            }}
          />

          <Button
            onClick={() => {
              document.querySelector('#rswp-card-button').click();
              setLoading(true);
            }}
            className="btn btn-dark w-100"
            disabled={loading}
          >
            Upgrade Card
          </Button>
        </PaymentForm>
      </ModalBody>
    </Modal>
  );
}
